var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8576 42.8574H34.2861V51.4289H42.8576V42.8574Z",
    fill: "#B73FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4289 17.1426H42.8574V25.714H51.4289V17.1426Z",
    fill: "#B73FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4289 34.2852H42.8574V42.8566H51.4289V34.2852Z",
    fill: "#B73FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4289 25.7148H42.8574V34.2863H51.4289V25.7148Z",
    fill: "#B73FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 25.7148H17.1426V34.2863H25.714V25.7148Z",
    fill: "#B73FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8566 8.57129H34.2852V17.1427H42.8566V8.57129Z",
    fill: "#B73FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2853 17.1426H25.7139V25.714H34.2853V17.1426Z",
    fill: "#B73FFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 8.57129H17.1426V17.1427H25.714V8.57129Z",
    fill: "#B73FFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2863 25.7148H25.7148V34.2863H34.2863V25.7148Z",
    fill: "#B73FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2863 34.2852H25.7148V42.8566H34.2863V34.2852Z",
    fill: "#B73FFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 34.2852H17.1426V42.8566H25.714V34.2852Z",
    fill: "#B73FFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8566 25.7148H34.2852V34.2863H42.8566V25.7148Z",
    fill: "#B73FFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8566 34.2852H34.2852V42.8566H42.8566V34.2852Z",
    fill: "#B73FFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2853 42.8574H25.7139V51.4289H34.2853V42.8574Z",
    fill: "#B73FFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2863 8.57129H25.7148V17.1427H34.2863V8.57129Z",
    fill: "#B73FFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 42.8574H17.1426V51.4289H25.714V42.8574Z",
    fill: "#B73FFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8576 17.1426H34.2861V25.714H42.8576V17.1426Z",
    fill: "#B73FFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 17.1426H17.1426V25.714H25.714V17.1426Z",
    fill: "#B73FFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1427 17.1426H8.57129V25.714H17.1427V17.1426Z",
    fill: "#B73FFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1427 25.7148H8.57129V34.2863H17.1427V25.7148Z",
    fill: "#B73FFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1427 34.2852H8.57129V42.8566H17.1427V34.2852Z",
    fill: "#B73FFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 0H17.1426V8.57143H25.714V0Z",
    fill: "#B73FFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1427 8.57129H8.57129V17.1427H17.1427V8.57129Z",
    fill: "#B73FFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 17.1426H0V25.714H8.57143V17.1426Z",
    fill: "#B73FFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 25.7148H0V34.2863H8.57143V25.7148Z",
    fill: "#B73FFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 34.2852H0V42.8566H8.57143V34.2852Z",
    fill: "#B73FFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1427 42.8574H8.57129V51.4289H17.1427V42.8574Z",
    fill: "#B73FFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 51.4287H17.1426V60.0001H25.714V51.4287Z",
    fill: "#B73FFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2863 51.4287H25.7148V60.0001H34.2863V51.4287Z",
    fill: "#B73FFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8566 51.4287H34.2852V60.0001H42.8566V51.4287Z",
    fill: "#B73FFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4289 42.8574H42.8574V51.4289H51.4289V42.8574Z",
    fill: "#B73FFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 34.2852H51.4287V42.8566H60.0001V34.2852Z",
    fill: "#B73FFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 25.7148H51.4287V34.2863H60.0001V25.7148Z",
    fill: "#B73FFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 17.1426H51.4287V25.714H60.0001V17.1426Z",
    fill: "#B73FFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4289 8.57129H42.8574V17.1427H51.4289V8.57129Z",
    fill: "#B73FFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8576 0H34.2861V8.57143H42.8576V0Z",
    fill: "#B73FFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2853 0H25.7139V8.57143H34.2853V0Z",
    fill: "#B73FFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9969 36.6802H41.3267V31.2436H38.3473V33.9362H35.6868V36.6659H38.326V40H32.9709V33.9659H27.3182V39.9913H21.9625V36.6784H24.6053V33.9535H21.9503V31.2355H18.9788V36.6542H16V28.18H18.941V25.1568H21.9363V22.7236H24.6138V20.0025H27.292V22.695H32.9526V20H35.6594V22.7037H38.3339V25.1357H41.306V28.1633H44L43.9969 36.6802ZM27.5762 29.6696V26.6799H24.6407V29.6721L27.5762 29.6696ZM32.9953 29.6585H35.9284V26.6867H32.9953V29.6585Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.814f302c6cc049e1ddefb55fcabda0dd.svg";
export { ForwardRef as ReactComponent };